import styled from 'styled-components';

export const PopUpModifyWrapper = styled.div`
  .btn {
    width: 164px;
    border-radius: 0;
    padding: 16px 0;
  }
`;
